// DESCRIPCIÓN: Componente para mostrar LoadPanel

import { LoadPanel } from "devextreme-react";
import PropTypes from "prop-types";

const PLoadPanel = (props) => {
  return <LoadPanel visible={props.visible} shadingColor="#f6f6f666" message={props.message} showIndicator={true} showPane={false} position={{ of: props.of }} />;
};

PLoadPanel.propTypes = {
  visible: PropTypes.bool,
  of: PropTypes.string,
  message: PropTypes.string,
};

PLoadPanel.defaultProps = {
  visible: false,
  of: "",
  message: "",
};

export default PLoadPanel;
